<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :items-per-page="-1"
    :loading="loadingExpanded"
    item-key="filial"
    fixed-header
    loading-text="Carregando..."
    class="font-resp-tabela table-full-screen"
    height="calc(100vh - 285px)"
    hide-default-footer
    show-expand
    :single-expand="singleExpand"
    :expanded="expanded"
    @item-expanded="getDadosExpandedHistorico"
  >
    <template v-slot:progress>
      <v-progress-linear
        indeterminate
        rounded
        color="red"
        height="3"
      ></v-progress-linear>
    </template>

    <template v-slot:item.dia_mes_inicial="{ item }">
      <span v-for="(dado, idx) in item.dia_mes_inicial.split(',')" :key="idx">
        <p class="pa-0 ma-0">{{ dado }}</p>
      </span>
    </template>

    <template v-slot:item.dia_mes_final="{ item }">
      <span v-for="(dado, idx) in item.dia_mes_final.split(',')" :key="idx">
        <p class="pa-0 ma-0">{{ dado }}</p>
      </span>
    </template>

    <template v-slot:item.media_periodo_sazonalidade="{ item }">
      {{ Helpers.formatarValorComCasas(item.media_periodo_sazonalidade, 2) }}
    </template>

    <template v-slot:item.media_crescimento="{ item }">
      {{ Helpers.formatarValorComCasas(item.media_crescimento, 2) }}
    </template>

    <template v-slot:item.media_anterior="{ item }">
      {{ Helpers.formatarValorComCasas(item.media_anterior, 2) }}
    </template>

    <template v-slot:item.tempo_medio_ressuprimento="{ item }">
      {{ Helpers.formatarValorComCasas(item.tempo_medio_ressuprimento, 2) }}
    </template>

    <template v-slot:item.porcentagem="{ item }">
      {{ Helpers.formatarValorComCasas(item.porcentagem, 2) + '%' }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn icon @click="editarSazonalidadeFilial(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <template v-slot:expanded-item="{ headers }">
      <td :colspan="headers.length">
        <p class="ma-0 subtitle-1 font-weight-medium my-1">
          <v-icon left style="font-size: 20px">mdi-clock-outline</v-icon>
          Histórico
        </p>

        <v-divider></v-divider>

        <historico-sazonal
          :dessertsProps="dessertsExpanded"
        ></historico-sazonal>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import HistoricoSazonal from "./HistoricoSazonal.vue";
import SazonalidadeAPI from "../../../api/sazonalidade";

export default {
  components: { HistoricoSazonal },
  props: {
    produto: {
      type: Array
    }
  },
  data() {
    return {
      loadingExpanded: false,
      singleExpand: true,
      expanded: [],
      search: '',
      headers: [
        { text: 'Filial', value: 'filial' },
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Descrição', value: 'descricao_produto' },
        { text: 'Tempo Ressuprimento', value: 'tempo_medio_ressuprimento' },
        { text: 'Dia/Mês Inicial', value: 'dia_mes_inicial' },
        { text: 'Dia/Mês Final', value: 'dia_mes_final' },
        { text: 'Tipo Ajuste', value: 'tipo_ajute_formatado' },
        { text: 'Média Anterior', value: 'media_anterior' },
        { text: 'Porcentagem', value: 'porcentagem_filial' },
        { text: 'Média Aplicada', value: 'media_crescimento' },
        { text: 'Recorrência', value: 'recorrencia_formatada' },
        { text: '', value: 'actions' },
      ],
      desserts: [],
      dessertsSecond: [],
      dessertsExpanded: []
    }
  },

  watch: {
    produto(val) {
      this.desserts = val;
    }
  },

  computed: {
    ...mapGetters({
      grupo_id: "usuario/getGrupoCompras"
    }),
  },

  methods: {
    editarSazonalidadeFilial(item) {
      this.$emit('editar-sazonalidade-produto-filial', item);
    },

    getDadosExpandedHistorico(dado) {
      if (dado.value == true) {
        this.dessertsSecond = this.desserts;
        this.desserts = [dado.item];
      } else {
        this.desserts = this.dessertsSecond;
      }

      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idproduto: dado.item.idproduto,
        filial: dado.item.filial,
        grupo_id: this.grupo_id
      }

      this.$store.dispatch("loading/addRequisicao",
        SazonalidadeAPI.getDadosExpandedHistorico(headers, params)
          .then((response) => {
            const { token, dados_expanded } = response.data;
            localStorage.setItem("token", token);

            this.dessertsExpanded = dados_expanded;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      )
    }
  }
}
</script>

<style>

</style>
